

document.addEventListener("DOMContentLoaded", function () {

  const map = {};

  // Step 1: Add class to categories + create map
  document.querySelectorAll('.km-cat-item').forEach(item => {
    const link = item.querySelector('.km-cat-link');
    const target = item.getAttribute('data-target');

    if (!link || !target) return;

    let name = link.textContent.trim()
      .replace(/\s+/g, '_')     // spaces → underscores
      .replace(/[^\w\-]/g, ''); // remove special chars

    item.classList.add(name);
    map[target] = name;
  });

  // Step 2: Add same class to cards
  document.querySelectorAll('.km-card').forEach(card => {
    const panels = card.getAttribute('data-panel');
    if (!panels) return;

    panels.split(' ').forEach(panel => {
      if (map[panel]) {
        card.classList.add(map[panel]);
      }
    });
  });

});

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('.km-spec').forEach(spec => {
    const label = spec.querySelector('.km-spec__lbl');
    if (!label) return;

    let name = label.textContent.trim()
      .replace(/\s+/g, '_')     // spaces → underscores
      .replace(/[^\w\-]/g, ''); // remove special chars

    spec.classList.add(name);
  });

});

/* Slider functionality for product page product images */

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".product__media-list.custom-slider");
  if (!slider) return;

  const slides = slider.querySelectorAll(".slider__slide");
  let currentIndex = 0;

  // Create buttons dynamically
  const prevBtn = document.createElement("button");
  const nextBtn = document.createElement("button");

  prevBtn.innerHTML = "‹";
  nextBtn.innerHTML = "›";

  prevBtn.className = "custom-slider-prev";
  nextBtn.className = "custom-slider-next";

  slider.parentElement.appendChild(prevBtn);
  slider.parentElement.appendChild(nextBtn);

  // ---- Hide arrows if only 1 slide ----
  if (slides.length <= 1) {
    prevBtn.style.display = "none";
    nextBtn.style.display = "none";
  }

  function updateSlider() {
    slides[currentIndex].scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest"
    });
  }

  nextBtn.addEventListener("click", function () {
    if (currentIndex < slides.length - 1) {
      currentIndex++;
      updateSlider();
    }
  });

  prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  // Optional: swipe support
  let startX = 0;

  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener("touchend", (e) => {
    let endX = e.changedTouches[0].clientX;

    if (startX - endX > 50 && currentIndex < slides.length - 1) {
      currentIndex++;
    } else if (endX - startX > 50 && currentIndex > 0) {
      currentIndex--;
    }

    updateSlider();
  });
});

/* Slider end */
